<template>
    <ModalFormCard
        :action="'/user-setting/' + editingModel.id"
        class="modal-default"
        :submittedCallback="submitted"
        v-bind="{ errors, saving }"
        :toast="toast"
    >
        <template #title>
            <template v-if="confirmed && value.move_to_id == -1">Delete files and folder</template>
            <template v-if="confirmed && value.move_to_id != -1">Delete folder</template>
            <template v-if="!confirmed">{{ 'Manage ' + $help.pluralize(setting.countName(), editingModel.count) }}</template>
        </template>

        <input type="hidden" name="_method" value="DELETE" />
        <input type="hidden" name="key" :value="setting.key" />

        <template v-if="!confirmed">
            <p class="text-15">
                There {{ editingModel.count == 1 ? 'is' : 'are' }} {{ editingModel.count }}
                {{ $help.pluralize(setting.countName(), editingModel.count) }} in "{{ editingModel.name }}", what would you like to do with
                {{ editingModel.count != 1 ? 'these files' : 'this file' }} once the folder has been deleted?
            </p>

            <Select
                v-if="setting.key != 'pipeline_stage'"
                class="mt-4"
                name="move_to_id"
                :label="'Manage files'"
                placeholder="Select an option"
                :options="filesActions"
                v-model:value="value.move_to_id"
            >
                <template #option="{ option, selected }">
                    <div class="flex items-center">
                        <div
                            class="w-2 h-2 rounded-full mr-2"
                            v-if="option.color != undefined"
                            :style="{ backgroundColor: option.color }"
                        />
                        <p class="text-15 font-normal">{{ option.html }}</p>
                    </div>
                </template>
            </Select>
        </template>

        <template v-if="confirmed">
            <input type="hidden" name="_method" value="DELETE" />
            <input type="hidden" name="new_status" :value="value.move_to_id" />

            <p class="text-15">
                Are you sure you want to delete the "{{ editingModel.name }}" folder<template v-if="newStatus == false">?</template>
                <template v-if="newStatus != false && value.move_to_id == -1"> and all its files</template>
                <template v-if="newStatus != false && value.move_to_id != -1">
                    and move {{ editingModel.count }} {{ $help.pluralize('file', editingModel.count) }} to
                    {{ newStatus.replace('Move files to', '') }}</template
                >
                <template v-if="newStatus != false">? </template>
                <template v-if="newStatus != false && value.move_to_id == -1">This action cannot be undone.</template>
            </p>
        </template>

        <div class="modal-buttons">
            <ButtonSaving
                v-if="!confirmed"
                type="button"
                class="button-black h-12 col-span-2"
                @click="confirmed = true"
                :disabled="value.move_to_id == null"
            >
                Next
            </ButtonSaving>

            <ButtonSaving v-if="confirmed" :disabled="saving" class="button-black h-12 col-span-2"> Delete </ButtonSaving>

            <div>
                <ButtonSaving v-if="!confirmed" :disabled="saving" type="button" class="button-purple default" @click="$emit('close')">
                    Cancel
                </ButtonSaving>
                <ButtonSaving
                    v-if="confirmed"
                    :disabled="saving"
                    type="button"
                    class="button-purple default"
                    @click="
                        () => {
                            if (editingModel.count == 0) {
                                this.$emit('close')
                            } else {
                                value.move_to_id = null
                                confirmed = false
                            }
                        }
                    "
                >
                    Cancel
                </ButtonSaving>
            </div>
        </div>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'
import Setting from '~/models/setting.js'

export default {
    mixins: [Modal],

    data() {
        return {
            action: this.isEdit ? '/setting/' + this.editingModel.id : '/setting',
            value: {
                move_to_id: null,
            },
            confirmed: this.editingModel.count == null || this.editingModel.count == 0,
            noConfirm: this.editingModel.count == null || this.editingModel.count == 0,
        }
    },

    methods: {
        submitted(res) {
            this.$authSanctum.getUser(true)
            this.$event.$emit('deal-stages-updated', res)
            this.$event.$emit('modal-form-completed')
            this.$event.$emit('modal-close')
        },
    },

    computed: {
        filesActions() {
            let folders = []

            folders.push(
                ...this._options.folders
                    .filter((f) => f.id != this.editingModel.id)
                    .map((f) => {
                        return {
                            value: f.id,
                            html: 'Move files to ' + this.$help.capitalizeFirstLetter(f.name),
                        }
                    }),
            )

            folders.push({
                value: -1,
                html: 'Delete all files',
            })

            return folders
        },

        newStatus() {
            if (this.editingModel.count != null && this.value.move_to_id != null) {
                return (this.setting.key == 'pipeline_stage' ? this.stages : this.filesActions).find(
                    (s) => s.value == this.value.move_to_id,
                ).html
            }

            return false
        },

        stages() {
            return this.options.stages
                .filter((s) => {
                    return s.id != this.editingModel.id
                })
                .map((s) => {
                    return {
                        value: s.id,
                        html: this.$help.capitalizeFirstLetter(s.name),
                        color: s.color,
                    }
                })
        },

        setting() {
            return new Setting(this.editingModel)
        },

        toast() {
            return this.$help.capitalizeFirstLetter(this.setting.me()) + ' deleted'
        },
    },
}
</script>
